module.exports = __webpack_public_path__ + "img/study-space.c86fb221.svg";